import { Action } from "@ngrx/store";
import { UserState } from "../reducers/user.reducer";
import { UserTypes } from "../../models/types";

export const LOGOUT = "[user] ResetState";
export const LOGIN = "[user] Login";
export const SET_JWT = "[user] SetJWT";
export const LANGUAGE = "[user] Language";
export const UPDATE = "[user] Update";

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */

export class SetJWTAction implements Action {
  readonly type = SET_JWT;
  constructor(public payload: { jwt: string; userType: UserTypes }) {}
}
export class LoginAction implements Action {
  readonly type = LOGIN;
  constructor(public payload: Partial<UserState>) {}
}
export class LogoutAction implements Action {
  readonly type = LOGOUT;
  constructor() {
    // No payload as the LogoutAction resets state
  }
}
export class UpdateAction implements Action {
  readonly type = UPDATE;
  constructor(public payload: Partial<UserState>) {}
}
export class LanguageAction implements Action {
  readonly type = LANGUAGE;
  constructor(public payload: { language: "en-GB" | "da-DK" }) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | LogoutAction
  | LoginAction
  | SetJWTAction
  | UpdateAction
  | LanguageAction;



// WEBPACK FOOTER //
// ./src/app/store/actions/user.actions.ts